import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaFileImport, FaCalendarAlt, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import AsyncSelect from 'react-select/async';
import { hasPerm, formataCNPJ, formataCPF, getCurrentUser, tiposAcesso, prestadoresCategorias } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ExportPDF from "./ExportPDF";
import ExportCSVExcel from "./ExportCSVExcel";

class Prestadores extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);
        this.handleChangeBusca = this.handleChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaPrestador = this.buscaPrestador.bind(this);   
        
        const dados_usuario = getCurrentUser();

        this.state = {
            listRegistros: [],
            error: "",
            prestador_id: "",
            page_numb: 1,
            loading: true,
            busca_nome: '',
            filtro_cpf_cnpj: '',
            categoria:'',
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_cadastro_teste: false,
            programa_select_key: 0,
            categoria_select_key: 0,
            showModal: false,
            permite_editar: true,
            envioCadastroMedicoPendente: false,
            file: false
        };
        
        // Bind de métodos
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this)
    }

    componentDidMount(){
        this.consultaRegistro(this.state.busca_nome, this.state.page_numb)
    }

    // Método para abrir o Modal
    handleShowModal() {
        this.setState({ showModal: true });
    }

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });            
            }            
        }
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                prestador_select_key: prevState.categoria_select_key + 1 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangeDebounced = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
        
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        
        this.searchTimeout = setTimeout(() => {
            this.setState({ loading: true, page_numb: 1 }, () => {
                this.consultaRegistro(name === 'busca_nome' ? value : this.state.busca_nome, 1);
            });
        }, 700);
    };

    // Método para fechar o Modal
    handleCloseModal() {
        this.setState({ showModal: false });
    }

    handleFileChange(event) {
        const file = event.target.files[0];
        this.setState({ file }, () => {
            console.log('Arquivo selecionado:', this.state.file);
        });
    }

    consultaRegistro(busca_nome = '', page_numb = 1) {
        let dados_usuario = getCurrentUser();
        
        let url = `/pessoas/prestadores/?nome=${busca_nome}&page=${page_numb}`;
    
        if (dados_usuario['ambiente_programa_id']) {
            url += `&programa_id=${dados_usuario['ambiente_programa_id']}`;
        }
    
        if (this.state.filtro_cpf_cnpj) {
            url += `&cpf_cnpj=${this.state.filtro_cpf_cnpj}`;
        }

        if (this.state.categoria) {
            url += `&categoria=${this.state.categoria}`;
        }

        if(this.state.filtro_cliente_id){
            url += '&cliente_id='+this.state.filtro_cliente_id
        }

        if(this.state.filtro_programa_id){
            url += '&programa_id='+this.state.filtro_programa_id
        }

        if(this.state.filtro_cadastro_teste){
            url += '&cadastro_teste=1';
        }

        if (this.state.envioCadastroMedicoPendente) {
            url += `&envio_cadastro_medico_pendente=1`;
        }
    
        this.setState({ loading: true }); // Exiba o carregamento enquanto a solicitação está em andamento
    
        api.get(url)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    busca_nome,
                    page_numb 
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar os provedores, tente novamente.';
    
                if(error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if(error.response.status === 403){
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }
    
                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });

            this.verificaBloqueioEdicao()
        
    }
    
    exibeCpfCnpj = (tipo_pessoa, cpf_cnpj) => {
        if(!cpf_cnpj || !tipo_pessoa){
            return '---'
        }

        if(tipo_pessoa === 'juridica'){
            return formataCNPJ(cpf_cnpj)
        }
        else {
            return formataCPF(cpf_cnpj)
        }
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                    {item.nome}
                    {
                    item.nome_fantasia &&
                    <>
                        <br />
                        <small>
                            Nome fantasia: {item.nome_fantasia}
                        </small>
                    </>
                    }                    
                </td>
                <td>{this.exibeCpfCnpj(item.tipo_pessoa, item.cpf_cnpj)}</td>
                <td>{item.email || '---'}</td>
                <td>{prestadoresCategorias[item.categoria] || '---'}</td>
                <td>{item.telefone || '---'}</td>
                <td>{item.celular || '---'}</td>
                <td className="d-none">{item.registro} / {item.registro_uf}</td>
                <td>
                    {
                    this.state.permite_editar &&
                    <Button variant="light" href={"/prestadores/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>    
                    }        
                    {this.state.permite_editar && (
              <Button
                variant="light"
                href={"/prestadores/agenda/" + item.id}
                size="sm"
              >
                <FaCalendarAlt /> Agenda
              </Button>
            )}            
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={8}>Nenhum provedor cadastrado</td>
            </tr>
        );
    };

    handleChangeBusca = (event, fieldName) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleCheckboxChange = (event) => {
        this.setState({ envioCadastroMedicoPendente: event.target.checked });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca_nome, num_page)
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.nome_fantasia} (${cliente.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.filtro_cliente_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.filtro_cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    handleImportar = () => {
        const { filtro_cliente_id, filtro_programa_id, categoria, file } = this.state;
    
        if (!filtro_cliente_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo cliente deve ser preenchido.',
            });
            return;
        }
        if (!filtro_programa_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo programa deve ser preenchido.',
            });
            return;
        }
        if (!categoria) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo categoria deve ser preenchido.',
            });
            return;
        }
        if (!file) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo de arquivo CSV deve ser preenchido.',
            });
            return;
        }
        if (!file.name.endsWith('.csv')) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O arquivo deve ser do tipo CSV.',
            });
            return;
        }

        const formData = new FormData();
        formData.append('cliente_id', filtro_cliente_id);
        formData.append('programa_id', filtro_programa_id);
        formData.append('categoria', categoria);
        formData.append('file', file);
    
        api.post('/pessoas/importar_medicos/', formData)
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Importação realizada com sucesso.',
                });
    
                
                this.handleCloseModal()
                this.props.router.navigate("/prestadores?envio_cadastro_medico_pendente=1");
                this.setState({ envioCadastroMedicoPendente: true }, () => {
            });
                
            })
            .catch(error => {
                let errorMessage = 'Houve um erro ao importar os médicos. Tente novamente.';
            
                // Verifica se existe uma mensagem de erro específica no response
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                }
            
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: errorMessage, // Mostra a mensagem de erro da API, se disponível
                });
            });
    }

    buscaPrestador(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaRegistro(this.state.busca_nome)
    };

    buscaCategoria(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaRegistro()
    };
    
    limpaFiltro = () => {
        this.setState({
            busca_nome: '',
            filtro_cpf_cnpj: '',
            categoria: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
            filtro_cadastro_teste: false,
            envioCadastroMedicoPendente: false,
            page_numb: 1
        }, () => {
            this.consultaRegistro('', 1);
        })
    }

    confirmarEnvioCadastro = () => {
        Swal.fire({
            title: 'Atenção!',
            text: "Deseja realmente enviar o email de confirmação de cadastro?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, enviar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.enviarConfirmacaoCadastro();
            }
        });
    }

    carregarProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    enviarConfirmacaoCadastro = () => {
        const { filtro_cliente_id, filtro_programa_id, categoria } = this.state;
    
        const payload = {
            cliente_id: filtro_cliente_id,
            programa_id: filtro_programa_id,
            categoria: categoria,
        };
        
        api.post('/pessoas/email-cadastro/', payload)
            .then(response => {
                Swal.fire(
                    'Enviado!',
                    'O email de confirmação de cadastro foi enviado com sucesso.',
                    'success'
                );
                    this.props.router.navigate("/prestadores")
            })
            .catch(error => {
                Swal.fire(
                    'Erro!',
                    'Ocorreu um erro ao enviar o email de confirmação.',
                    'error'
                );
            });
    }

    render() {
        const customStyles = {
            option: (provided, state) => ({
              ...provided,
              fontSize: '13px',
            }),
            singleValue: (provided, state) => ({
              ...provided,
              fontSize: '13px',
            }),
          };

        if (!hasPerm('view_prestadores')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Provedores</h4>
                    </Col>
                    {hasPerm('add_prestadores') && (
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/prestadores/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar provedor
                        </Button>
                    </Col>
                    )}
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaPrestador}>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome</Form.Label>                                  
                                        <Form.Control
                                            type="text"
                                            name="busca_nome"
                                            value={this.state.busca_nome}
                                            onChange={this.handleChangeDebounced}
                                            placeholder="Nome do provedor"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>CPF/CNPJ</Form.Label>                                  
                                        <Form.Control
                                            type="text"
                                            name="filtro_cpf_cnpj"
                                            value={this.state.filtro_cpf_cnpj}
                                            onChange={this.handleChangeDebounced}
                                            placeholder="Apenas números ou formatado"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Categoria</Form.Label>                                  
                                        <Form.Control as="select" name="categoria" value={this.state.categoria} onChange={this.handleChangeBusca}>
                                        <option value="">Categoria do Provedor</option>
                                            {Object.entries(prestadoresCategorias).map(([chave, valor]) => (
                                                <option key={chave} value={chave}>{valor}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                {(dados_usuario['tipo_usuario'] == '') && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder="Buscar programa..."
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                            </Row>
                            <Row>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="filtroCadastroTestePrestadores"
                                            label="Apenas provedores de teste"
                                            checked={this.state.filtro_cadastro_teste}
                                            onChange={e => this.setState({ filtro_cadastro_teste: e.target.checked })}
                                        />
                                    </Form.Group>
                                </Col>
                                {dados_usuario['tipo_usuario'] == '' && hasPerm('import_prestadores') && (
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="envioCadastroMedicoPendente"
                                            label="Envio de e-mail de cadastro pendente"
                                            checked={this.state.envioCadastroMedicoPendente}
                                            onChange={this.handleCheckboxChange}
                                        />
                                    </Form.Group>
                                </Col>                                                      
                                )}
                            </Row>
                            <Row className="mb-4">
                                <Col sm={6}>
                                    <Button type="submit" variant="secondary" size="sm">
                                        <FaSearch /> Filtrar
                                    </Button>
                                    <Button className="ms-2" type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                        <FaEraser /> Limpar Filtro
                                    </Button>
                                </Col>
                                <Col sm={6} className="text-end">
                                    <ExportCSVExcel />
                                    <ExportPDF />
                                    {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'gestor') && hasPerm('import_prestadores') && (
                                        <Button variant="light" className="ms-2" size="sm" onClick={this.handleShowModal}>
                                            <FaFileImport /> Importar Médicos
                                        </Button>
                                    )}
                                    {this.state.envioCadastroMedicoPendente && this.state.listRegistros.results.length > 0 && hasPerm('import_prestadores') && (
                                        <Button variant="primary" className="ms-2" size="sm" onClick={this.confirmarEnvioCadastro}>
                                            <FaFileImport /> Enviar confirmação de cadastro
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </Form> 

                        {/* Modal para importação de arquivo */}
                        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Importar Provedores de Serviço</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {dados_usuario['ambiente_cliente_id'] === "" && (
                                <Col> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cliente</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarClientes}
                                            defaultOptions
                                            name="cliente_id"
                                            placeholder="Buscar cliente..."
                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                            value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_cliente_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect          
                                            key={this.state.programa_select_key}                                  
                                            cacheOptions
                                            loadOptions={this.carregaProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_programa_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Categoria</Form.Label>                                  
                                        <Form.Control 
                                            key={this.state.categoria_select_key}                
                                            as="select" name="categoria" value={this.state.categoria} onChange={this.handleChangeFiltros}>
                                        <option value="">Categoria do Provedor</option>
                                            {Object.entries(prestadoresCategorias).map(([chave, valor]) => (
                                                <option key={chave} value={chave}>{valor}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.categoria && (
                                 <Form.Group>
                                    <Form.Label>Selecione um arquivo CSV para importar:</Form.Label>
                                    <Form.Control 
                                        type="file" 
                                        required={true}
                                        accept=".csv"
                                        onChange={this.handleFileChange}
                                    />
                                </Form.Group>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="" onClick={this.handleCloseModal}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.handleImportar}>
                                    Importar
                                </Button>
                            </Modal.Footer>
                        </Modal>   

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>CPF/CNPJ</th>
                                    <th>Email</th>
                                    <th>Categoria</th>
                                    <th>Telefone</th>
                                    <th>Celular</th>
                                    <th className="d-none">Registro</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={8}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={8}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Prestadores);
